import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * X (formerly Twitter) logo icon - simple logo mark without background
 * Use this for custom styling with your own underlay
 *
 * @example
 * ```tsx
 * // With default underlay
 * <XIcon size="md" withUnderlay />
 *
 * // With custom underlay
 * <XIcon
 *   size="md"
 *   withUnderlay
 *   underlayClassName="size-10 bg-custom"
 * />
 * ```
 */
export const XIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="X" viewBox="0 0 15 14" {...props}>
      <path
        d="M0.0365853 0L5.82851 7.7228L0 14H1.3125L6.41387 8.50261L10.5366 14H15L8.88338 5.84397L14.3072 0H12.997L8.29802 5.06189L4.50229 0H0.0365853ZM1.96646 0.962215H4.01753L13.0724 13.0355H11.0213L1.96646 0.962215Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
});

XIcon.displayName = "XIcon";
